import { jsx } from "react/jsx-runtime";
import { gridClasses } from "@mui/x-data-grid-pro";
import { useMemo } from "react";
import { DataTableExpandableCell } from "./DataTableExpandableCell.js";
import { DATA_TABLE_COMPACT_DENSITY_FACTOR } from "./model.js";
const ENABLE_EXPANDABLE_CELLS_CLASS_NAME = `${gridClasses.root}--expandableCells`;
const EXPANDABLE_CELL_NESTED_TEXT_CONTENT_CLASS_NAME = `${gridClasses.cellContent}--nestedText`;
const EXPANDABLE_CELL_FLEX_WRAP_CLASS_NAME = `${gridClasses.cellContent}--flexWrap`;
const useExpandableCells = ({ enableExpandableCells, columns: initColumns, rowHeight: initRowHeight, getRowHeight, compact })=>{
    const columns = useMemo(()=>{
        if (!enableExpandableCells) return initColumns;
        return initColumns.map((column)=>{
            const { disableExpandableCell, renderCell, ...otherColumn } = column;
            if (disableExpandableCell) return column;
            const updatedColumn = {
                ...otherColumn,
                renderCell: (params)=>{
                    const { formattedValue, value } = params;
                    let cellChildren;
                    if (renderCell) cellChildren = renderCell(params);
                    else {
                        const valueToRender = null == formattedValue ? value : formattedValue;
                        cellChildren = valueToRender?.toString();
                    }
                    return /*#__PURE__*/ jsx(DataTableExpandableCell, {
                        children: cellChildren
                    });
                }
            };
            return updatedColumn;
        });
    }, [
        enableExpandableCells,
        initColumns
    ]);
    const sx = useMemo(()=>{
        if (!enableExpandableCells) return;
        const rowHeightFactor = compact ? DATA_TABLE_COMPACT_DENSITY_FACTOR : 1;
        const defaultRowHeight = initRowHeight * rowHeightFactor;
        let rowHeight = defaultRowHeight;
        if (getRowHeight) try {
            const calculatedRowHeight = getRowHeight({
                densityFactor: rowHeightFactor
            });
            if ('number' == typeof calculatedRowHeight && calculatedRowHeight > 0) rowHeight = calculatedRowHeight;
        } catch (_e) {}
        return {
            [`&.${ENABLE_EXPANDABLE_CELLS_CLASS_NAME}`]: {
                [`& .${gridClasses.cell}:hover`]: {
                    [`& .${gridClasses.cellContent}`]: {
                        paddingTop: (theme)=>`calc((${rowHeight}px - 1px - ${theme.typography.body2.lineHeight}) / 2)`,
                        paddingBottom: (theme)=>`calc((${rowHeight}px - 1px - ${theme.typography.body2.lineHeight}) / 2)`
                    }
                }
            }
        };
    }, [
        compact,
        enableExpandableCells,
        getRowHeight,
        initRowHeight
    ]);
    return {
        className: enableExpandableCells ? ENABLE_EXPANDABLE_CELLS_CLASS_NAME : void 0,
        columns,
        sx
    };
};
export { ENABLE_EXPANDABLE_CELLS_CLASS_NAME, EXPANDABLE_CELL_FLEX_WRAP_CLASS_NAME, EXPANDABLE_CELL_NESTED_TEXT_CONTENT_CLASS_NAME, useExpandableCells };

//# sourceMappingURL=useExpandableCells.js.map